<template>
  <component :is="page" :id="id" :theme="theme" />
</template>

<script>
import { computed } from "vue";
import { flows } from "@/pages/ExternalPages";

export default {
  name: "External",
  props: {
    flow: {
      type: String,
      required: true,
    },
    step: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: String,
    },
    theme: String,
  },
  setup(props) {
    const page = computed(() => {
      const key = Object.keys(flows).find((k) => flows[k].name === props.flow);
      return flows[key].pages[props.step || flows[key].defaultStep];
    });

    return {
      page,
    };
  },
};

// X two factor - YES
// X forgot password / password reset - KEEP EXISTING SETUP
// X what is storebuilder login for? - SWITCH CLIENT
// X multiple parallel shopping cart states? - NO
// X styling of components - YES RESTYLE STUFF
// X exit button - YES
// X chatbutton? - YES
// X analytics / cartstack (YES GA, NO CARTSTACK)
// X ability to remove domains from cart - YES
// X coupons for domains? - NO
</script>
